// Add all polyfills for older browsers
import '@babel/polyfill';
import './customevent.js';
import './remove.js';
import './element/closest.js';
